<!-- <my-content placeholder="navigation">
  <div class="col-sm-12 divbordergry"></div> -->
  <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            <label> {{ ModelFor }}</label>
          </h4>
          <br />
          <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body col-sm-12 form-group">
          <iframe width="100%" Height="400 px" [src]="modalURL | safe"></iframe>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="divider"></div> -->

  @if (true) {
<div class="container-fluid">
  <div class="table-header-container">
    <div class="table-heading">
      Manage Company Master
    </div>
    <form [formGroup]="FormSearchContactOrg" (ngSubmit)="onSearchContactOrg(FormSearchContactOrg.value)">
      <div class="d-flex">
        <div class="input-group">
          <input type="text" placeholder="Search here..." class="table-search-input form-control"
            formControlName="txtSearch">
          <span class="input-group-btn">
            <button class="btn btn-primary" title="Search">
              <i class="fas fa-magnifying-glass"></i>
            </button>
          </span>
        </div>
        <button class="btn btn-outline-primary mx-2" title="Create Company" routerLink="/company-master/company/0" >
              <i class="fas fa-plus"></i>
        </button>
      </div>
    </form>
  </div>
  <div class="d-flex align-items-center justify-content-between my-3">
    <div class="active-user-card d-flex">
      <div class="card-left w-100 p-4">
        <img class="card-icon" src="../../../assets/icons/active-user-icon.svg" alt="">
        <div class="card-title mt-2">Company</div>
        <div class="card-count">
          {{ TotalConsumedCompany }}/{{ totalAssignCompany }}
        </div>
      </div>
      <div class="card-right">
        <img class="card-bg-icon" src="../../../assets/icons/active-user-bg-icon.svg" alt="">
      </div>
    </div>
  </div>
  <div class="card table-container">
    <table class="custom-table">
      <thead>
        <tr>
          <th>S.No.</th>
          <th>Name</th>
          <th>Address</th>
          <th>State</th>
          <th>City</th>
          <th>Mobile No</th>
          <th>Email</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <app-table-state [loading]="MsgType == 1"
          [error]="MsgType == 3 ? DisplayMessage ?? 'Something went wrong while fetching data.' : null"
          [empty]="filteredData?.length == 0" [rows]="10" [columns]="8">
        </app-table-state>
        @if (filteredData?.length>0) {
        @for (cm of filteredData | paginate : { itemsPerPage: pageSize, currentPage: pageNumber }; track $index ; let i
        = $index) {
        <tr>
          <td align="center">{{ (pageNumber - 1) * pageSize + i + 1 }}</td>
          <td>{{ cm.Name }}</td>
          <td>{{ cm.Address }}</td>
          <td>{{ cm.PState }}</td>
          <td>{{ cm.PCity }}</td>
          <td>{{ cm.Mobile }}</td>
          <td>{{ cm.Email1 }}</td>
          <td>
            <div class="form-group col-sm-6" *ngIf="
                  this.RightsID.includes('202044001') ||
                    this.RightsID.includes('202044021');
                  then EditCompanyLink;
                  else EditCompany
                "></div>
            <ng-template #EditCompanyLink>
              <a title="Edit Company Details" routerLink="/company-master/company/{{ cm.id }}">
                <i class="fa fa-pencil font-16 theme-icon"></i>
              </a>
            </ng-template>
            <ng-template #EditCompany>
              <a href="module/0">
                <i class="fa fa-pencil font-16 theme-icon"></i>
              </a>
            </ng-template>
          </td>
        </tr>
        }
        }
      </tbody>
    </table>
  </div>
  @if (filteredData?.length > 0) {
    <div class="d-flex justify-content-between my-3 w-100">
        <div class="w-50">
            <app-rows-per-page
            [pageSize]="pageSize"
            [total]="totalRecords"
            [pageIndex]="pageNumber"
            (pageSizeChange)="onPageSizeChange($event)">
        </app-rows-per-page>
        </div>
        <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
    </div>
  }
  <!-- @if (MsgType == 0 && filteredData?.length>0) {
  <div class="d-flex justify-content-end my-3">
    <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
  </div>
  } -->
</div>
  } @else {
    <!-- <div class="card toolbar-card">
      <div class="row">
        <div class="col-sm-6">
          <form #SearchContactOrg="ngForm" [formGroup]="FormSearchContactOrg"
            (ngSubmit)="onSearchContactOrg(SearchContactOrg.value)">
            <div class="col-sm-7">
              <input class="form-control" formControlName="txtSearch" placeholder="Search here" name="txtSearch"
                type="text" value="" />
            </div>
            <div class="col-sm-2">
              <input class="btn btn-primary btn-sm-12" type="submit" value="Go" />
            </div>
          </form>
        </div>
        <div class="col-sm-3"></div>
  
        <div class="col-sm-3 text-right">
          <div class="form-group " *ngIf="
              this.RightsID.includes('202044021') && this.CompanyCondition == 1;
              then AddCompanyLink;
              else AddCompany
            "></div>
          <ng-template #AddCompanyLink>
            <div class=" height-34 d-flex align-items-center justify-content-end">
              <a routerLink="/company-master/company/0" title="Create Company">
                <i class="material-icons" style="
                cursor: pointer;
                padding: 7px;
                border: 1px solid #dfdfdf;
                border-radius: 4px;
                background: linear-gradient(
                  20.39deg,
                  rgb(255 255 255) 15.57%,
                  rgb(255 255 255) 100.74%
                ) !important;
              ">add</i>
              </a>
            </div>
          </ng-template>
          <ng-template #AddCompany>
            <div class="col-sm-6">&nbsp;</div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="row stats-row">
      <div class="col-sm-4">
        <div class="stat-card">
          <div class="stat-title">Company</div>
          <div class="stat-value">
            {{ this.TotalConsumedCompany }}/{{ this.totalAssignCompany }}
          </div>
        </div>
      </div>
    </div>
  
    <div class="panel panel-default employees-panel">
      <div class="panel-heading">
        <div class="row">
          <div class="col-sm-6">
            <h4 class="panel-title">
              <i class="fa fa-building header-icon"></i>
              Manage Company Master
            </h4>
          </div>
        </div>
      </div>
      <div class="panel-body panel-body-table">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Name</th>
                <th>Address</th>
                <th>State</th>
                <th>City</th>
                <th>Mobile No</th>
                <th>Email</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
  
              <tr *ngIf="this.MsgType == 1">
                <td colspan="80">
                  <div class="d-flex align-items-center">
                    <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                    <div class="spinner-border" role="status"></div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="this.MsgType == 2">
                <td colspan="80">
                  &nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                  <span>{{ DisplayMessage }}</span>
                </td>
              </tr>
              <tr *ngIf="this.MsgType == 3">
                <td colspan="80">
                  <span class="Err">{{ DisplayMessage }}</span>
                </td>
              </tr>
  
              <tr *ngFor="
                    let cm of CompanyMaster
                      | paginate : { itemsPerPage: 7, currentPage: pageNumber };
                    let i = index
                  ">
                <td align="center">{{ (pageNumber - 1) * 7 + i + 1 }}</td>
                <td>{{ cm.Name }}</td>
                <td>{{ cm.Address }}</td>
                <td>{{ cm.PState }}</td>
                <td>{{ cm.PCity }}</td>
                <td>{{ cm.Mobile }}</td>
                <td>{{ cm.Email1 }}</td>
                <td>
                  <div class="form-group col-sm-6" *ngIf="
                        this.RightsID.includes('202044001') ||
                          this.RightsID.includes('202044021');
                        then EditCompanyLink;
                        else EditCompany
                      "></div>
                  <ng-template #EditCompanyLink>
                    <a title="Edit Company Details" routerLink="/company-master/company/{{ cm.id }}">
                      <i class="fa fa-pencil font-16 theme-icon"></i>
                    </a>
                  </ng-template>
                  <ng-template #EditCompany>
                    <a href="module/0">
                      <i class="fa fa-pencil font-16 theme-icon"></i>
                    </a>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
  
          <div class="panel-footer">
            <div class="pagination-wrapper">
              <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div> -->

  }
<!-- 
</my-content>
<my-content placeholder="main"> </my-content> -->